module.exports = __webpack_public_path__ + "img/tony.399aa421.jpeg";